import React from "react";
import styled, { keyframes } from "styled-components";

const spin = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

const LoaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: ${({ minHeight }) => minHeight || "100vh"};
  flex-direction: column;
  gap: ${({ gap }) => gap || "16px"};
  padding: ${({ padding }) => padding || "20px"};
`;

const Spinner = styled.div`
  width: ${({ size }) => size || "40px"};
  height: ${({ size }) => size || "40px"};
  border: 3px solid ${({ theme }) => theme.colors.border.secondaryLight};
  border-top: 3px solid
    ${({ theme, color }) => color || theme.colors.main.primary};
  border-radius: 50%;
  animation: ${spin} 1s linear infinite;
`;

const LoaderText = styled.p`
  color: ${({ theme, color }) => color || theme.colors.main.textSecondary};
  font-size: ${({ fontSize }) => fontSize || "14px"};
  font-weight: ${({ theme }) => theme.fontWeights.medium};
  margin: 0;
  text-align: center;
`;

const Loader = ({
  size = "40px",
  color,
  text,
  minHeight = "100vh",
  gap = "16px",
  padding = "20px",
  fontSize,
  textColor,
}) => {
  return (
    <LoaderContainer minHeight={minHeight} gap={gap} padding={padding}>
      <Spinner size={size} color={color} />
      {text && (
        <LoaderText color={textColor} fontSize={fontSize}>
          {text}
        </LoaderText>
      )}
    </LoaderContainer>
  );
};

export default Loader;
